<template>
    <path fill-rule="evenodd"
          d="M6.93 20.003c-.065.005-.138.004-.205.023-.534.15-.838.72-.686 1.252.15.532.7.834 1.235.683a.99.99 0 0 0 .686-1.23.994.994 0 0 0-1.03-.727zM1 2.57v18.86c0 .864.633 1.57 1.412 1.57h9.176C12.37 23 13 22.3 13 21.43V2.57C13 1.706 12.367 1 11.588 1H2.412C1.63 1 1 1.7 1 2.57zM0 2.4C0 1.075.984 0 2.21 0h9.58C13.01 0 14 1.078 14 2.4v19.2c0 1.325-.984 2.4-2.21 2.4H2.21C.99 24 0 22.922 0 21.6V2.4zM1 18h12v1H1v-1zm8-7.5L5 14V7l4 3.5z"/>
</template>

<script>
export default {
    name: 'rewardedVideoIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 14 24');
    }
};
</script>
